import { isValidBaseReference } from './base.validator';

/**
 * Validates a resource metadata download count by ensuring it is a non-negative integer.
 * @param {unknown} download_count The download count value to validate.
 * @returns {boolean} `true` if the download count is valid, `false` otherwise.
 */
export const isValidResourceMetadataDownloadCount = (download_count: unknown): boolean =>
  typeof download_count === 'number' && Number.isInteger(download_count) && download_count >= 0;

/**
 * Validates a resource metadata master list resource reference by ensuring it is a non-null object with an id property.
 * @param {unknown} reference The master_list_resource value to validate.
 * @returns {boolean} `true` if the reference is valid, `false` otherwise.
 */
export const isValidMasterListResourceReference = (reference: unknown): boolean =>
  isValidBaseReference(reference);
